import { Menu, MenuItem } from "@mui/material";
import styled from "styled-components";

export const NewReqNameAndActionsText = styled.div`
  color: ${({ theme }) => theme.greyMedium};
  text-align: left;
  user-select: all;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  gap: 8px;
`;

export const NewReqNameWithStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

export const NewReqNameStatusIcon = styled.span`
  display: inline-flex;
`;

const ACTION_BUTTON_SIZE = 32;
const ACTION_BUTTON_HORIZONTAL_MARGIN = 2;
const ACTION_GROUP_HORIZONTAL_PADDING = 4;

const actionButtonOuterWidth =
  ACTION_BUTTON_SIZE + ACTION_BUTTON_HORIZONTAL_MARGIN * 2;

export const NewReqButtonGroupWrapper = styled.div<{
  $actionCount: number;
}>`
  visibility: hidden;
  flex-shrink: 0;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  max-width: ${({ $actionCount }) =>
    `${$actionCount * actionButtonOuterWidth + ACTION_GROUP_HORIZONTAL_PADDING}px`};
  margin-right: -8px;
  z-index: 1;

  .MuiButtonGroup-root {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: none;
    /* Left edge carries the Ordered row hover colour so the bar fades out of
       the row; cc is the same 80% alpha the right edge uses. */
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.greenSubtle}cc 0%,
      ${({ theme }) => theme.greenSubtle}cc 10%,
      rgba(255, 200, 195, 0.8) 100%
    );
    padding: 4px 2px;
    border-radius: 0 32px 32px 0;
  }

  /* Match Completed/Archived: AG Grid hover class only (not row focus). */
  .ag-row-hover.row-electronic-order & {
    visibility: visible;
  }

  /* Hold the bar open for the overflow menu and for keyboard users. The menu
     hands focus back before it closes, and :focus-visible only keeps the bar
     up when that hand-off came from the keyboard, so a pointer close still
     dismisses it. */
  &:has(:focus-visible, [aria-expanded="true"]) {
    visibility: visible;
  }
`;

/** Tooltip needs a non-disabled wrapper when the button itself is disabled. */
export const NewReqActionButtonSlot = styled.span`
  display: flex;
  align-items: center;
`;

export const NewReqHoverButton = styled.button<{ $isDisabled?: boolean }>`
  background: transparent;
  color: ${({ theme }) => theme.redMedium};
  border: none;
  border-radius: 50%;
  min-width: ${ACTION_BUTTON_SIZE}px;
  width: ${ACTION_BUTTON_SIZE}px;
  height: ${ACTION_BUTTON_SIZE}px;
  padding: 0;
  margin: 0 ${ACTION_BUTTON_HORIZONTAL_MARGIN}px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 14px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};

  svg path {
    fill: ${({ theme }) => theme.redMedium};
  }

  &:hover {
    background: ${({ $isDisabled, theme }) =>
      $isDisabled ? "transparent" : theme.redMedium};
    color: ${({ $isDisabled, theme }) =>
      $isDisabled ? theme.redMedium : theme.white};

    svg path {
      fill: ${({ $isDisabled, theme }) =>
        $isDisabled ? theme.redMedium : theme.white};
    }
  }

  &:active {
    background: ${({ $isDisabled, theme }) =>
      $isDisabled ? "transparent" : theme.redDark};
    color: ${({ $isDisabled, theme }) =>
      $isDisabled ? theme.redMedium : theme.white};

    svg path {
      fill: ${({ $isDisabled, theme }) =>
        $isDisabled ? theme.redMedium : theme.white};
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.greenDark};
    outline-offset: 2px;
  }
`;

/** Shared tooltip body for Ordered row action and status-icon labels. */
export const NewReqActionTooltip = styled.div`
  margin-top: 4px;
  font-size: 14px;
  padding: 3px;
`;

export const EditOrderTooltipText = styled.div`
  font-family: light;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`;

export const NewReqOverflowMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: max-content;
    padding: 16px;
    border-radius: 10px;
    box-shadow: ${({ theme }) => theme.boxShadow};
  }

  .MuiList-root {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0;
  }
`;

export const NewReqOverflowMenuItem = styled(MenuItem)`
  && {
    min-height: 44px;
    padding: 8px;
    border-radius: 4px;
    color: ${({ theme }) => theme.neutral700};
    font-family: light;
    font-size: 18px;
    line-height: 28px;

    &:hover,
    &.Mui-focusVisible {
      background-color: ${({ theme }) => theme.greenSubtle};
    }
  }
`;
